import React, { useEffect, useRef, useState } from "react";
import registerImage from "../assets/formatRifa_Papel.png";
import { IoIosSave } from "react-icons/io";
import { doc, setDoc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import SelectStatus from "./SelectStatus";
import { GrPowerReset } from "react-icons/gr";
import swal from "sweetalert";
import { Notyf } from "notyf";
import { IoCloseCircle } from "react-icons/io5";
import "notyf/notyf.min.css";
import ImageWithRect from "./ImageWithReact";
import { getStatusIcon, getStatusNameIcon } from "../utils";
import TicketNavigator from "./TicketNavigator";

const RaffleTicket = ({
  number,
  setNumber,
  raffleId,
  onlyView,
  handleSelectNum,
  imageUrl,
  ticketList
}) => {
  const ticketRef = useRef();
  const notyf = new Notyf({
    duration: 2000,
    position: {
      x: "right",
      y: "top",
    },
  });

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [status, setStatus] = useState(1); // Estado por defecto

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, "tickets", `${raffleId}_${number}`),
      (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          setName(data.name);
          setPhone(data.phone);
          setStatus(data.status || 1);
        } else {
          // Si el ticket no existe, restablece los valores por defecto
          setName("");
          setPhone("");
          setStatus(1);
        }
      }
    );

    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [number, raffleId]);

  const closeTicket = () => {
    handleSelectNum(null);
  };

  const handleReserveTicket = async () => {
    if (!name) {
      notyf.error("Nombre requerido.");
      return;
    }

    // const phonePattern = /^[0-9+\-\s]{7,15}$/;

    // if (!phone) {
    //   notyf.error("Teléfono requerido.");
    //   return;
    // }

    // if (!phonePattern.test(phone)) {
    //   notyf.error("Teléfono inválido.");
    //   return;
    // }

    try {
      await setDoc(doc(db, "tickets", `${raffleId}_${number}`), {
        name,
        phone,
        status: Number(2),
        number,
        raffleId: `${raffleId}`, // Guardamos también el ID de la rifa
      });

      swal(`Perfecto!`, `Boleto N° ${number} reservado con exito!`, "success");
    } catch (e) {
      console.error("Error reservando el ticket: ", e);
      swal(`Error!`, `Error reservando el ticket!`, "error");
    }
  };

  const handleSaleTicket = async () => {
    if (!name) {
      notyf.error("Nombre requerido.");
      return;
    }

    try {
      await setDoc(doc(db, "tickets", `${raffleId}_${number}`), {
        name,
        phone,
        status: Number(3),
        number,
        raffleId: `${raffleId}`, // Guardamos también el ID de la rifa
      });

      swal(`Perfecto!`, `Boleto N° ${number} vendido con exito!`, "success");
    } catch (e) {
      console.error("Error vendiendo el ticket: ", e);
      swal(`Error!`, `Error vendiendo el ticket!`, "error");
    }
  };

  const resetTicket = async () => {
    // Pregunta al usuario si está seguro de que desea reiniciar el ticket
    const confirmation = await swal({
      title: "Confirmar Reinicio",
      text: "¿Deseas reiniciar este ticket?",
      icon: "warning",
      buttons: ["Cancelar", "Reiniciar"],
      dangerMode: true,
    });
  
    // Si el usuario confirma, procede a reiniciar el ticket
    if (confirmation) {
      // Restablece los valores locales
      setName("");
      setPhone("");
      setStatus(1);
  
      try {
        // Actualiza la base de datos en Firebase con los valores predeterminados
        await setDoc(doc(db, "tickets", `${raffleId}_${number}`), {
          name: "",
          phone: "",
          status: 1,
          number,
          raffleId: `${raffleId}`,
        });
        notyf.success("Ticket disponible nuevamente!");
      } catch (e) {
        console.error("Error al restablecer el ticket: ", e);
        swal(`Error!`, `Error al restablecer el ticket!`, "error");
      }
    }
  };
  

  const formData = (
    <div
      className="flex flex-wrap gap-4 p-6 m-4 rounded-2xl  bg-white relative"
      style={{
        boxShadow: "2px 2px 2px 4px rgba(0, 0, 0, 0.10)",
      }}
      ref={ticketRef}
    >
      <div className="w-full">
        <div className="flex justify-between">
        <TicketNavigator tickets={ticketList} currentNumber={number} setNumber={setNumber} />
          <div>

        </div>
          {onlyView && (
            <ImageWithRect
              imageSrc={imageUrl}
              number={number}
              description={`${name} (${phone}) `}
              raffleId={raffleId}
              imageUrl={imageUrl}
            />
          )}
        </div>

        {Number(status) !== 1 && (
          <div className="w-full">
            <small>
              Boleto {Number(status) === 3 && "pagado por "}
              {Number(status) === 2 && "reservado a "} <strong>"{name}"</strong>
            </small>
          </div>
        )}
        <div
          className="flex flex-1 min-w-[300px] gap-2"
          style={{ alignItems: "center" }}
        >
          <label className="block text-gray-500 mb-1 font-bold">Estado: </label>
          <div className="relative">{getStatusNameIcon(status)}</div>
        </div>
        <hr className="mt-2" />
      </div>

      <div
        className="flex-1/2 min-w-[250px]"
        hidden={Number(status) !== 1 && !onlyView}
      >
        <label className="block text-gray-500 mb-1">Nombre <span className="text-red-800">*</span></label> 
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div
        className="flex-1/2 min-w-[250px]"
        hidden={Number(status) !== 1 && !onlyView}
      >
        <label className="block text-gray-500 mb-1">Teléfono</label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>

      <div className="w-full">
      </div>
      <div className="w-full flex">
        <div className="flex w-full gap-2">
          {onlyView && (
            <div>
            <button
              onClick={resetTicket}
              className="flex align-center justify-center gap-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
              style={{ alignItems: "center" }}
            >
              <GrPowerReset size={20} /> <span className="hidden hover:block">Reset</span>
            </button>
          </div>
          )}

{
  (Number(status) !== 2 && onlyView) || Number(status) === 1 ? (
    <div>
      <button
        onClick={handleReserveTicket}
        className="flex align-center text-sm text-white justify-center gap-2 bg-gray-800 border-solid hover:bg-gray-700 py-2 px-4 rounded-full"
      >
        {getStatusIcon(2)} Reservar
      </button>
    </div>
  ) : null
}

          {
            onlyView &&  Number(status) !== 3 && (<div>
            <button
              onClick={handleSaleTicket}
              className="flex align-center text-sm text-white justify-center gap-2 bg-gray-800 border-solid hover:bg-gray-700 py-2 px-4 rounded-full"
            >
              {getStatusIcon(3)} Vender
            </button>
          </div> )
}
        </div>

        <div className="w-full flex justify-end">
          <div className="close-button" onClick={() => closeTicket()}>
            <IoCloseCircle size={16} />
            Cerrar
          </div>
        </div>
      </div>
    </div>
  );

  return <div>{formData}</div>;
};

export default RaffleTicket;
